export default "__VITE_ASSET__DaVS2CkN__"